import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@pg-env/environment';

@Injectable()
export class ChartDataService {
  public api: string;

  constructor(private http: HttpClient) {
    this.api = environment.customerApiUrl;
  }

  public getDonutChart(): Observable<any> {
    return this.http.get(`${this.api}/chart/get-referral-activity-chart`);
  }

  public getStackBarChartData(): Observable<any> {
    return this.http.get(`${this.api}/chart/get-conversion-chart`);
  }

  public getFunnelChartData(): Observable<any> {
    return this.http.get(`${this.api}/chart/get-opportunity-pipeline-chart`);
  }

  public getEstimateFunnelChartData(): Observable<any> {
    return this.http.get(`${this.api}/chart/get-estimated-opportunity-pipeline`);
  }

  public getAreaChartData(): Observable<any> {
    return this.http.get(`${this.api}/chart/get-commission-chart`);
  }
}
